import { jsx as _jsx } from "react/jsx-runtime";
if (process.env.NODE_ENV === "development") {
    require("preact/devtools");
}
import TestNow from "../../speedcurve-components/src/components/TestNow";
import renderDashboard from "../../speedcurve-components/src/lib/render-dashboard";
import "../../speedcurve-components/src/style/global.scss";
const testPermissionUser = window.SPEEDCURVE_CONFIG.userAccountTestPermission;
if (testPermissionUser) {
    renderDashboard(_jsx(TestNow, {}), "test-now-mount-point");
}
